import Icon from "../Icon/Icon"
import React, {ReactElement} from "react"
import classNames from "classnames"

interface ImageTransformControlsProps {
	className?: string
	/** Render a single <button> (no wrapper) so segmented border-radius matches first/last controls. */
	leadingSlot?: ReactElement<HTMLButtonElement>
	changeRotation: () => void
	zoomIn: () => void
	zoomOut: () => void
	zoomVal: number
}

export function ImageTransformControls(props: ImageTransformControlsProps) {
	const {leadingSlot, changeRotation, zoomIn, zoomOut, zoomVal, className} = props

	return (
		<div className={classNames("image-transform-controls", className)}>
			{leadingSlot}
			<button
				aria-label="rotation button"
				onClick={(e) => {
					e.stopPropagation()
					changeRotation()
				}}
			>
				<Icon icon="design-tool-rotate-clockwise" />
			</button>

			<button
				aria-label="zoom in button"
				onClick={(e) => {
					e.stopPropagation()
					zoomIn()
				}}
				disabled={zoomVal === 2}
			>
				<Icon icon="zoom-in" />
			</button>
			<button
				aria-label="zoom out button"
				onClick={(e) => {
					e.stopPropagation()
					zoomOut()
				}}
				disabled={zoomVal === 1}
			>
				<Icon icon="zoom-out" />
			</button>
		</div>
	)
}
